// @ts-nocheck

import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import { get } from 'lodash'
import theme from '../../../LEGACY/theme'
import DateField from './DateField'

export default function BirthdateField(props) {
  const { formKey, values, disabled, compactAge, ...rest } = props
  const value = get(values, formKey)
  const age = dayjs().diff(dayjs(value, 'DD-MM-YYYY'), 'years')
  const displayAge = isNaN(parseInt(age)) ? 0 : age
  return (
    <DateField {...rest} formKey={formKey} values={values} disabled={disabled}>
      {value && (
        <div
          style={{
            ...localStyles.ageWrapper,
            // Compact keeps the age snug against the input so the DOB input
            // stays as wide as the other fields in the card (CM-3877); the
            // default flex:1 splits the field column evenly with the input.
            ...(compactAge && localStyles.ageWrapperCompact)
          }}
          className="age-value"
        >
          <div style={localStyles.ageText}>Age</div>
          <div
            style={{
              ...localStyles.ageValue,
              ...(disabled && localStyles.disabled)
            }}
          >
            {displayAge}
          </div>
        </div>
      )}
    </DateField>
  )
}

const localStyles = {
  ageWrapper: {
    display: 'flex',
    flex: 1,
    marginRight: 15
  },
  ageWrapperCompact: {
    flex: 'none',
    marginRight: 0
  },
  ageText: {
    paddingTop: 7
  },
  ageValue: {
    background: colors.grey,
    borderRadius: 5,
    fontWeight: 600,
    height: theme.input.height,
    marginLeft: 5,
    padding: '7px 10px 0px 10px'
  },
  disabled: {
    opacity: 0.39
  }
}
